var map = {
	"./accounts/accounts.module": [
		"./src/app/accounts/accounts.module.ts",
		"default~accounts-accounts-module~erp-erp-module",
		"accounts-accounts-module"
	],
	"./ecommerce/ecommerce.module": [
		"./src/app/ecommerce/ecommerce.module.ts",
		"ecommerce-ecommerce-module"
	],
	"./erp/erp.module": [
		"./src/app/erp/erp.module.ts",
		"default~erp-erp-module~hrms-hrms-module~service-module-service-module",
		"default~erp-erp-module~service-module-service-module",
		"default~accounts-accounts-module~erp-erp-module",
		"erp-erp-module"
	],
	"./hrms/hrms.module": [
		"./src/app/hrms/hrms.module.ts",
		"default~erp-erp-module~hrms-hrms-module~service-module-service-module",
		"hrms-hrms-module"
	],
	"./service-module/service.module": [
		"./src/app/service-module/service.module.ts",
		"default~erp-erp-module~hrms-hrms-module~service-module-service-module",
		"default~erp-erp-module~service-module-service-module",
		"service-module-service-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;